export const plans = [
  {
    name: "Starter",
    planKey: "starter_quarterly",
    subtitle: "Occasional Researcher (quarterly cadence)",
    price: 3800,
    priceDisplay: "$3,800",
    period: "/quarter",
    billedText: "Billed Quarterly · $3,800 per project",
    billingCycle: "quarterly",
    credits_score: 60000,
    project_limits: 1,
    question_count: 75,
    overageRate: 0.25,
    termMonths: 0,
    noticeDays: 0,
    features: [
      { text: "60,000 Research Units (RUs)²", included: true, tier: "yellow" },
      { text: "$0.25 Overage Cost per RU", included: true, tier: "yellow" },
      { text: "1 Project per Quarter¹", included: true, tier: "yellow" },
      { text: "Banner Book Included", included: true, tier: "single" },
      {
        text: "Summary Findings Report Included",
        included: true,
        tier: "single",
      },
      {
        text: "75 Avatar Questions / quarter (with rollover)³",
        included: true,
        tier: "yellow",
      },
      {
        text: "Additional Collaborators: Unlimited⁴",
        included: true,
        tier: "single",
      },
      { text: "No Minimum Term⁶", included: true, tier: "single" },
      { text: "Cancel Anytime⁵", included: true, tier: "single" },
    ],
    buttonText: "Choose Plan",
  },
  {
    name: "Growth",
    planKey: "growth_monthly",
    subtitle: "Growing Research Team",
    price: 6000,
    priceDisplay: "$6,000",
    period: "/month",
    billedText: "Billed Monthly · $3,000 per project",
    billingCycle: "monthly",
    badge: "Recommended",
    credits_score: 100000,
    project_limits: 2,
    question_count: 300,
    overageRate: 0.2,
    termMonths: 6,
    noticeDays: 60,
    features: [
      { text: "100,000 Research Units (RUs)²", included: true, tier: "single" },
      { text: "$0.20 Overage Cost per RU", included: true, tier: "single" },
      { text: "2 Monthly Projects¹", included: true, tier: "single" },
      { text: "Banner Book Included", included: true, tier: "single" },
      {
        text: "Summary Findings Report Included",
        included: true,
        tier: "single",
      },
      {
        text: "300 Avatar Questions / month (with rollover)³",
        included: true,
        tier: "single",
      },
      {
        text: "Additional Collaborators: Unlimited⁴",
        included: true,
        tier: "single",
      },
      { text: "6-Month Minimum Term⁶", included: true, tier: "single" },
      { text: "60 day Cancellation Notice⁵", included: true, tier: "single" },
    ],
    buttonText: "Choose Plan",
    highlighted: true,
  },
  {
    name: "Scale",
    planKey: "scale_monthly",
    subtitle: "High-Volume Research Team",
    price: 13500,
    priceDisplay: "$13,500",
    period: "/month",
    billedText: "Billed Monthly · $2,700 per project",
    billingCycle: "monthly",
    credits_score: 250000,
    project_limits: 5,
    question_count: null,
    overageRate: 0.15,
    termMonths: 12,
    noticeDays: 90,
    features: [
      { text: "250,000 Research Units (RUs)²", included: true, tier: "double" },
      { text: "$0.15 Overage Cost per RU", included: true, tier: "double" },
      { text: "5 Monthly Projects¹", included: true, tier: "double" },
      { text: "Banner Book Included", included: true, tier: "single" },
      {
        text: "Summary Findings Report Included",
        included: true,
        tier: "single",
      },
      { text: "Unlimited Avatar Questions³", included: true, tier: "double" },
      {
        text: "Additional Collaborators: Unlimited⁴",
        included: true,
        tier: "single",
      },
      { text: "12-Month Minimum Term⁶", included: true, tier: "double" },
      { text: "90 day Cancellation Notice⁵", included: true, tier: "double" },
    ],
    buttonText: "Choose Plan",
  },
];

export const oneTimeStudy = {
  name: "Pay as You Go",
  subtitle: "Infrequent Researcher",
  price: 5500,
  priceDisplay: "$5,500",
  billingCycle: "one_time",
  credits_score: 50000,
  project_limits: 1,
  question_count: 100,
  overageRate: 1.0,
  features: [
    { text: "1 Project¹", included: true },
    { text: "50,000 Research Units (RUs)²", included: true },
    { text: "$1.00 Overage Cost per RU", included: true },
    { text: "100 Avatar Questions³", included: true },
    { text: "Banner Book Included", included: true },
    { text: "Summary Findings Report Included", included: true },
    { text: "Additional Collaborators: Unlimited⁴", included: true },
  ],
};

export const studentPlan = {
  name: "Student",
  subtitle: "Student Researcher (.edu email)",
  price: 500,
  priceDisplay: "$500",
  billingCycle: "one_time",
  credits_score: 25000,
  project_limits: 1,
  question_count: 75,
  overageRate: 1.0,
  features: [
    { text: "1 Project¹", included: true },
    { text: "25,000 Research Units (RUs)²", included: true },
    { text: "$1.00 Overage Cost per RU", included: true },
    { text: "75 Avatar Questions³", included: true },
    { text: "Banner Book Included", included: true },
    { text: "Summary Findings Report Included", included: true },
    { text: "Additional Collaborators: Unlimited⁴", included: true },
  ],
};

export const legacyPlans = [
  {
    name: "Personal",
    planKey: "personal_monthly",
    isLegacy: true,
    subtitle: "Company Researcher (legacy plan)",
    price: 7500,
    priceDisplay: "$7,500",
    period: "/month",
    billedText: "Billed Monthly",
    billingCycle: "monthly",
    credits_score: 50000,
    project_limits: 1,
    question_count: 75,
    overageRate: 0.25,
    noticeDays: 45,
    features: [
      { text: "50,000 Research Units (RUs)" },
      { text: "$0.25 Overage Cost per RU" },
      { text: "1 Monthly Project" },
      { text: "75 Avatar Questions / month" },
      { text: "45 day Cancellation Notice" },
    ],
  },
  {
    name: "Professional",
    planKey: "professional_monthly",
    isLegacy: true,
    subtitle: "Research Power User(s) (legacy plan)",
    price: 17500,
    priceDisplay: "$17,500",
    period: "/month",
    billedText: "Billed Monthly",
    billingCycle: "monthly",
    credits_score: 180000,
    project_limits: 3,
    question_count: 300,
    overageRate: 0.2,
    noticeDays: 60,
    features: [
      { text: "180,000 Research Units (RUs)" },
      { text: "$0.20 Overage Cost per RU" },
      { text: "3 Monthly Projects" },
      { text: "300 Avatar Questions / month" },
      { text: "60 day Cancellation Notice" },
    ],
  },
  {
    name: "Enterprise",
    planKey: "enterprise_monthly",
    isLegacy: true,
    subtitle: "Broad Corporate Access (legacy plan)",
    price: 27500,
    priceDisplay: "$27,500",
    period: "/month",
    billedText: "Billed Monthly",
    billingCycle: "monthly",
    credits_score: 450000,
    project_limits: 6,
    question_count: null,
    overageRate: 0.15,
    noticeDays: 90,
    features: [
      { text: "450,000 Research Units (RUs)" },
      { text: "$0.15 Overage Cost per RU" },
      { text: "6 Monthly Projects" },
      { text: "Unlimited Avatar Questions" },
      { text: "90 day Cancellation Notice" },
    ],
  },
];

export const planMapping = {
  Starter: {
    price: 3800,
    credits_score: 60000,
    project_limits: 1,
    question_count: 75,
  },
  Growth: {
    price: 6000,
    credits_score: 100000,
    project_limits: 2,
    question_count: 300,
  },
  Scale: {
    price: 13500,
    credits_score: 250000,
    project_limits: 5,
    question_count: null,
  },
  "Pay as You Go": {
    price: 5500,
    credits_score: 50000,
    project_limits: 1,
    question_count: 100,
  },
  Student: {
    price: 500,
    credits_score: 25000,
    project_limits: 1,
    question_count: 75,
  },
  Freemium: {
    price: "FREE",
    credits_score: 0,
    project_limits: 0,
    question_count: 0,
  },
  Custom: {
    price: 0,
    credits_score: 0,
    project_limits: 0,
    question_count: 0,
  },
};

export const getPlanByName = (planName) => {
  if (!planName) return null;
  const name = typeof planName === "string" ? planName : planName.planName;

  return planMapping[name] || null;
};

const ALL_PLAN_DEFINITIONS = [
  ...plans,
  oneTimeStudy,
  studentPlan,
  ...legacyPlans,
];

export const findPlanDefinition = (planName) => {
  if (!planName) return null;
  return ALL_PLAN_DEFINITIONS.find((p) => p.name === planName) || null;
};

export const getPlanKey = (planName) =>
  findPlanDefinition(planName)?.planKey || null;

export const isSubscriptionPlan = (planName) => Boolean(getPlanKey(planName));

const DEFAULT_OVERAGE_RATE = 0.25;
export const getOverageRate = (planName) =>
  findPlanDefinition(planName)?.overageRate ?? DEFAULT_OVERAGE_RATE;

export const getBillingPeriodLabel = (planName) =>
  findPlanDefinition(planName)?.billingCycle === "quarterly"
    ? "Quarter"
    : "Month";
